import { render, staticRenderFns } from "./PresalePhotoBook.vue?vue&type=template&id=0922f074&scoped=true"
import script from "./PresalePhotoBook.vue?vue&type=script&lang=js"
export * from "./PresalePhotoBook.vue?vue&type=script&lang=js"
import style0 from "./PresalePhotoBook.vue?vue&type=style&index=0&id=0922f074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922f074",
  null
  
)

export default component.exports